<template>
  <div :class="groupClass">
    <label :class="lableClass" :for="name">
      <slot>{{ title }}</slot>
    </label>

    <div :class="fieldClass">
      <!--Special Part Starts-->
      <multiselect
        v-model="value"
        :clear-on-select="!multiple"
        :close-on-select="!multiple"
        :custom-label="fullname"
        :hide-selected="multiple"
        :limit="50"
        :limit-text="limitText"
        :loading="!ready"
        :multiple="multiple"
        :options="designations"
        :options-limit="50"
        :placeholder="placeholder.length > 0 ? placeholder : 'Type to search'"
        :preserve-search="multiple"
        :show-labels="false"
        label="name"
        track-by="id"
        :searchable="false"
        :allow-empty="true"
        @input="update"
      >
        <template #noResult>
          <slot name="no-result">Oops! No result found.</slot>
        </template>
      </multiselect>
      <!--Special Part Ends-->

      <div
        v-if="form && form.errors.has(errorId)"
        class="invalid-feedback"
        v-text="form.errors.get(errorId)"
      ></div>
      <slot name="note"></slot>
    </div>

    <div :class="extraSlotClass">
      <slot name="extra">
        <button
          v-if="showResetButton"
          class="btn btn-danger"
          type="button"
          @click.prevent="reset()"
        >
          <font-awesome-icon :icon="['fal', 'times']" />
        </button>
      </slot>
    </div>
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,

  props: {
    excludeIds: {
      type: Array,
      default: () => [],
    },

    multiple: {
      default: false,
    },

    showResetButton: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      designations: [],
    };
  },

  async mounted() {
    if (this.designations.length === 0) {
      await this.getDesignations();
    }
  },

  methods: {
    reset() {
      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("change", null);
    },

    update(object) {
      if (object !== undefined && object !== null) {
        this.form[this.name] = object;
      }

      if (this.form) {
        this.form.errors.clear(this.errorId);
      }

      this.$emit("change", object);
    },

    fullname(designation) {
      return designation.name;
    },

    limitText(count) {
      return `and ${count} other designations`;
    },

    async getDesignations() {
      const excludeIds = this.excludeIds.join(",");

      const response = await this.$http.get(`/designations?with=fields&exclude_ids=${excludeIds}`);
      this.designations = [{ id: null, name: "NONE" }, ...response.body.data];
    },
  },
};
</script>
